import classNames from 'classnames';

import { ReviewsInCatalogContainer } from '@containers/ReviewsInCatalog';
import { SeoCatalogAlsoSearch, SeoCatalogAlsoSearchProps } from '@components/catalog/SeoCatalogAlsoSearch';
import { CatalogSiblings, Sibling } from '@components/catalog/CatalogSiblings';
import { TagGroupCrossLinking, TagGroupCrossLinkingProps } from '@components/catalog/TagGroupCrossLinking';
import { useCatalogRouteMatch, useSearchParams } from '@utils/common';
import { RichText } from '@ui/RichText';

import s from './SeoCatalogBlocks.sss';

type SeoCatalogBlocksProps = {
  alsoSearchTags: SeoCatalogAlsoSearchProps['tags'];

  siblings: Sibling[];

  tagGroupCrossLinking: TagGroupCrossLinkingProps['groups'];

  seoDescription?: string | null;

  citySlug?: string,

  className?: string
};

export const SeoCatalogBlocks: React.FC<SeoCatalogBlocksProps> = ({
  alsoSearchTags,
  siblings,
  tagGroupCrossLinking,
  seoDescription,
  citySlug,
  className,
}) => {
  const [params] = useSearchParams();
  const page = +(params.page || 1);
  const match = useCatalogRouteMatch();

  if (!match) {
    return null;
  }

  return (
    <section className={classNames(s.root, className)}>
      {/* REVIEWS BLOCK */}
      <ReviewsInCatalogContainer />

      {/* ALSO SEARCH BLOCK */}
      {
        alsoSearchTags.length > 0 && (
          <SeoCatalogAlsoSearch
            tags={alsoSearchTags}
          />
        )
      }

      <CatalogSiblings
        citySlug={citySlug}
        siblings={siblings}
      />

      {/* SEO STAFF BLOCK */}
      {
        page === 1 && Object.keys(params).length === 0 && tagGroupCrossLinking.length > 0 && (
          <TagGroupCrossLinking
            groups={tagGroupCrossLinking}
          />
        )
      }

      {/* SEO DESCRIPTION */}
      {seoDescription && (
        <RichText
          className={s.seoDescription}
          dangerouslySetInnerHTML={{ __html: seoDescription }}
        />
      )}
    </section>
  );
};
